import { CartUpdateEvent } from '@theme/events';

const RETURN_MARKER = 'driftaway:checkout-return-cart-sync';
const CART_COUNT_KEY = 'cart-count';
const SOURCE_ID = 'driftaway-checkout-return-cart-sync';

function isCheckoutSubmission(event) {
  const form = event.target;
  const submitter = event.submitter;

  if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form') return false;
  if (!(submitter instanceof HTMLElement)) return false;

  return submitter.id === 'checkout' || submitter.getAttribute('name') === 'checkout';
}

function markCheckoutReturn(event) {
  if (!isCheckoutSubmission(event)) return;

  try {
    sessionStorage.setItem(RETURN_MARKER, '1');
  } catch (_) {
    return;
  }
}

function readStoredCartCount() {
  try {
    const stored = sessionStorage.getItem(CART_COUNT_KEY);
    if (stored === null) return null;

    const parsed = JSON.parse(stored);
    const count = Number.parseInt(parsed?.value, 10);
    return Number.isInteger(count) && count >= 0 ? count : null;
  } catch (_) {
    return null;
  }
}

async function refreshNativeCartAfterCheckoutReturn() {
  let hasReturnMarker = false;

  try {
    hasReturnMarker = sessionStorage.getItem(RETURN_MARKER) === '1';
  } catch (_) {
    return;
  }

  if (!hasReturnMarker) return;

  const cartDrawer = document.querySelector('cart-drawer-component');
  const cartItems = cartDrawer?.querySelector('cart-items-component');
  const cartIcon = document.querySelector('cart-icon');

  try {
    sessionStorage.removeItem(RETURN_MARKER);
  } catch (_) {
    return;
  }

  if (!(cartDrawer instanceof HTMLElement)) return;
  if (!(cartItems instanceof HTMLElement)) return;
  if (!(cartIcon instanceof HTMLElement)) return;

  await Promise.all([
    customElements.whenDefined('cart-drawer-component'),
    customElements.whenDefined('cart-items-component'),
    customElements.whenDefined('cart-icon'),
  ]);

  const storedCount = readStoredCartCount();
  const iconCount = Number.parseInt(String(cartIcon.currentCartCount), 10);
  const itemCount =
    storedCount !== null
      ? storedCount
      : Number.isInteger(iconCount) && iconCount >= 0
        ? iconCount
        : null;

  if (itemCount === null) return;

  document.dispatchEvent(
    new CartUpdateEvent({ item_count: itemCount }, SOURCE_ID, {
      itemCount,
      source: SOURCE_ID,
    })
  );
}

document.addEventListener('submit', markCheckoutReturn, { capture: true });
window.addEventListener('pageshow', refreshNativeCartAfterCheckoutReturn);
